(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yr-article"]) return;
  try {
    
function initJournalTables(){
  document.querySelectorAll('[data-yr-article]').forEach((body)=>{
    body.querySelectorAll('table').forEach((table)=>{
      if(table.dataset.yrTableReady)return;
      let wrapper=table.parentElement;
      if(wrapper===body||wrapper.children.length!==1||getComputedStyle(wrapper).overflowX==='visible'){
        wrapper=document.createElement('div');
        table.before(wrapper);
        wrapper.append(table);
      }
      wrapper.classList.add('yr-table-scroll');
      const original={tabindex:wrapper.getAttribute('tabindex'),role:wrapper.getAttribute('role'),label:wrapper.getAttribute('aria-label')};
      const caption=table.querySelector('caption')?.textContent.trim();
      const hint=document.createElement('p');
      hint.className='yr-table-hint';
      hint.textContent=body.dataset.yrTableHint;
      hint.hidden=true;
      wrapper.before(hint);
      const update=()=>{
        const overflowing=wrapper.scrollWidth> wrapper.clientWidth+1;
        hint.hidden=!overflowing;
        for(const [attribute,value] of [['tabindex',overflowing?'0':original.tabindex],['role',overflowing?'region':original.role],['aria-label',overflowing?(original.label||caption||body.dataset.yrTableLabel):original.label]]){
          if(value===null)wrapper.removeAttribute(attribute);else wrapper.setAttribute(attribute,value);
        }
      };
      table.dataset.yrTableReady='true';
      update();
      if('ResizeObserver' in window){const observer=new ResizeObserver(update);observer.observe(wrapper);observer.observe(table);}
      else window.addEventListener('resize',update,{passive:true});
      if(document.fonts)document.fonts.ready.then(update);
    });
  });
}
function initJournalContents(){
  initJournalTables();
  document.querySelectorAll('[data-yr-article]').forEach((body)=>{
    const toc=body.parentElement.querySelector('[data-yr-toc]');
    if(!toc||toc.dataset.ready)return;
    const headings=body.querySelectorAll('h2');
    if(headings.length<2)return;
    headings.forEach((heading,index)=>{
      if(!heading.id){let id='story-section-'+(index+1);while(document.getElementById(id))id+='-x';heading.id=id;}
      const link=document.createElement('a');link.href='#'+heading.id;link.textContent=heading.textContent;toc.querySelector('nav').append(link);
    });
    toc.hidden=false;toc.dataset.ready='true';
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initJournalContents);else initJournalContents();
document.addEventListener('shopify:section:load',initJournalContents);

  } catch(e) { console.error(e); }
})();
})();
